<template>
  <Settings :openByDefault="noSavedFilters" @openFilters="toggledSettings" />
</template>

<script>
import adminService from '../../services/admin.service';
import UtilService from '../../services/util';
import UniversityService from '../../services/university.service';
import FilterService from '../../services/filter';
import Settings from './Settings.vue';
import { userIconSvg } from '../../models/static';

export default {
  name: 'WebsocketHelper',
  data() {
    return {
      time: 0,
      pageLoadTime: Date.now(),
      wsConnection: null,
      isActive: true,
      showChatBot: false,
      userProfileImage: '',
      noSavedFilters: false,
      isSettingsOpen: false,
    };
  },
  components: {
    Settings,
  },
  created() {},
  async mounted() {
    if (this.currentUser) {
      this.userProfileImage =
        this.currentUser && this.currentUser.profileImage
          ? this.currentUser.profileImage
          : userIconSvg;
    }

    const noSavedFilters = localStorage.getItem('applicationFilters')
      ? false
      : true;

    if (noSavedFilters) {
      await this.$store
        .dispatch('application_filter/storeFetchIntakes')
        .then(() => {
          setTimeout(() => {
            this.noSavedFilters = true;
          }, 1000);
        });

      return;
    }

    this.$store
      .dispatch('application/storeFetchApplications')
      .then(async () => {
        await this.$store.dispatch('users/getAllUsers', this.currentUser.id);
        await this.$store.dispatch('application/storeFetchCourses');
        await this.$store.dispatch('application_filter/storeFetchIntakes');
        UniversityService.getAll().then(async (response) => {
          const totalNoOfApps = parseInt(
            this.$store.state.application.totalNoApplcations / 100,
            10
          );
          await this.$store.dispatch('users/getAllTeamLeaders').then(() => {
            this.$store.dispatch('application_filter/setInitialFilters', {
              apps: FilterService.queryFilters(
                this.$store.state.application.copyApplications
              ),
              universities: response.data,
              finishedLoading: totalNoOfApps === 0,
            });

            this.$store.dispatch('message/setInitialMessages', {
              messages: this.$store.state.application.applications,
              userId: this.currentUser.id,
            });

            this.$store.dispatch('auth/setInvoiceData');
          });

          for (let index = 0; index < totalNoOfApps; index++) {
            if (this.isSettingsOpen) {
              this.$store.dispatch('application_filter/setInitialFilters', {
                apps: FilterService.queryFilters(
                  this.$store.state.application.applications
                ),
                universities: response.data,
                finishedLoading: true,
              });
              break;
            }
            await this.$store
              .dispatch('application/storeFetchApplications')
              .then(() => {
                const finishedLoading = totalNoOfApps - 1 === index;
                this.$store.dispatch('application_filter/setInitialFilters', {
                  apps: FilterService.queryFilters(
                    this.$store.state.application.applications
                  ),
                  universities: response.data,
                  finishedLoading,
                });

                this.$store.dispatch('message/setInitialMessages', {
                  messages: this.$store.state.application.applications,
                  userId: this.currentUser.id,
                });
              });
          }
        });
      });

    // this.getUnreadMesssageCount()

    // const ws = await this.connectToServer();

    this.wsConnection = new WebSocket(process.env.VUE_APP_SOCKET_ENDPOINT);

    this.$eventHub.$on('socket__event', async (socketValue) => {
      if (this.wsConnection.readyState === 3) {
        this.wsConnection.close();
        this.wsConnection = new WebSocket(process.env.VUE_APP_SOCKET_ENDPOINT);

        // wait until new connection is open
        while (this.wsConnection.readyState !== 1) {
          await new Promise((r) => setTimeout(r, 250));
        }
      }

      this.wsConnection.send(JSON.stringify(socketValue));
    });

    this.wsConnection.onmessage = async (webSocketMessage) => {
      const parsedMessage = JSON.parse(webSocketMessage.data);
      if (parsedMessage && parsedMessage.messageType) {
        switch (parsedMessage.messageType) {
          case 'socket__new-student':
            this.showNotification(parsedMessage.messageValue);
            break;

          case 'socket__edit-student':
            this.showNotification(parsedMessage.messageValue);
            break;

          case 'socket__new-application':
            this.pushApplication(parsedMessage.messageValue);
            break;

          case 'socket__edit-application':
            this.editApplication(parsedMessage.messageValue);
            break;

          case 'socket__edit-message':
            this.editMessage(parsedMessage.messageValue);
            break;

          case 'socket__new-message':
            this.pushMessage(parsedMessage.messageValue);
            break;

          default:
            break;
        }
      }
    };

    document.addEventListener('visibilitychange', () => {
      this.isActive = !document.hidden;
      if (this.isActive) {
        this.pageLoadTime = Date.now() - this.time;
      }
    });

    window.addEventListener('beforeunload', this.leaving);

    this.intervalId = setInterval(() => {
      if (this.isActive) {
        this.time = Date.now() - this.pageLoadTime;
      }
    }, 1000);

    setInterval(() => {
      // this.getUnreadMesssageCount()
      this.storeUserTime();
    }, 30000);
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    isAdmin() {
      return UtilService.isAdmin();
    },
    isModerator() {
      return UtilService.isModerator();
    },
    isManager() {
      return UtilService.isManager();
    },
    getActiveConversation() {
      return UtilService.getActiveConversation();
    },
    savedTime() {
      return localStorage.getItem('timeSpentOnPage');
    },
  },
  methods: {
    async connectToServer() {
      const ws = new WebSocket(process.env.VUE_APP_SOCKET_ENDPOINT);
      return new Promise((resolve) => {
        const timer = setInterval(() => {
          if (ws.readyState === 1) {
            clearInterval(timer);
            resolve(ws);
          }
        }, 40000);
      });
    },

    shoulSeeApplication(application) {
      return (
        UtilService.isManagement() ||
        (UtilService.isTeamLeader() &&
          application.team.teamId === UtilService.currentUserTeam()) ||
        (this.currentUser && application.moderatorId === this.currentUser.id)
      );
    },

    toggleChatBot(causeByPressingEsc) {
      if (causeByPressingEsc && !this.showChatBot) {
        return;
      }

      this.showChatBot = !this.showChatBot;
    },

    showNotification(application) {
      if (this.shoulSeeApplication(application)) {
        this.$buefy.notification.open({
          indefinite: true,
          message: `<em>${application.message}</em>`,
          type: 'is-success',
          position: 'is-top-left',
          hasIcon: true,
        });
      }
    },

    pushApplication(application) {
      if (this.shoulSeeApplication(application)) {
        this.$store.dispatch('application/pushNewApplication', application);
      }
    },

    editApplication(application) {
      if (
        !UtilService.getStudentIdsForApps().includes(application.studentValue)
      ) {
        return;
      }

      this.$store.dispatch('application/toggleEditCell', application);

      if (application.path === 'isUrgent') {
        this.$buefy.toast.open({
          duration: 3000,
          message: application.value
            ? 'Student was added with urgent status'
            : 'Student was removed from urgent status',
          position: 'is-bottom',
          type: application.value ? 'is-danger' : 'is-success',
        });
      }
    },

    editMessage(message) {
      this.$store.dispatch('message/setMessage', {
        message,
      });
    },

    pushMessage(message) {
      if (
        UtilService.getAppIdForLoadedMessages().includes(message.applicationId)
      ) {
        const newMessage = {
          ...message,
          appId: message.applicationId,
          createdAt: new Date(),
          moderatorId: this.currentUser.id,
        };

        this.$store.dispatch('message/pushNewMessage', newMessage);
      }
    },

    leaving() {
      localStorage.setItem('timeSpentOnPage', this.time);
    },

    storeUserTime() {
      this.leaving();
      if (this.savedTime > 0 && this.currentUser && this.currentUser.id) {
        adminService
          .updateTimeSpent({
            userId: this.currentUser.id,
            time: this.savedTime,
            published_date: new Date().toISOString().slice(0, 10),
          })
          .then(() => {
            localStorage.setItem('timeSpentOnPage', this.time);
          });
      }
    },

    getUnreadMesssageCount() {
      if (!this.currentUser) {
        return;
      }

      this.$store.dispatch('message/getMessages', this.currentUser);
    },

    toggledSettings(value) {
      this.isSettingsOpen = value;
    },
  },
};
</script>

<style>
.bubble {
  --r: 25px;
  /* the radius */
  --t: 30px;
  /* the size of the tail */

  position: relative;
  max-width: 100%;
  padding: calc(var(--r) / 2);
  background: rgb(10, 124, 255);
  color: #fff;
  border-radius: 8px;
  padding-bottom: 12px;
}

.left {
  --_d: 0%;
  /* margin-left: var(--t); */
  background: #a3a3a3;
}

.right {
  --_d: 100%;
  margin-left: var(--t);
}

.seen-message {
  /* position: absolute; */
  /* color: red; */
  right: 0;
  bottom: 4px;
}

.left .seen-message {
  left: 32px;
}

.message-sender {
  color: #ffefd0;
  font-weight: bold;
  font-size: 12px;
}

.status-submitted {
  background: #d7f3f4 !important;
}

.status-info-required {
  background: #f8d856 !important;
}

.status-deferral-requested {
  background: #d590e8 !important;
}

.status-deferred {
  background: #bea3f4 !important;
}

.status-enrolled {
  background: #171817 !important;
  color: #fff;
}

.status-danger {
  background: #ff958a !important;
}

.status-case-pending {
  background: #c28d3c !important;
}

.status-case-settled {
  background: #cb933f !important;
}

.status-existing {
  background: #6f85e6 !important;
}

.status-not-interested {
  background: #a6a6a6 !important;
}

.status-nude {
  background: #ffefd0 !important;
}

.status-not-approved,
.is_draft {
  background: #50504f !important;
  color: #fff;
  cursor: not-allowed;
}

.is_draft {
  background: #0a0a0a !important;
}

.button.is-success {
  color: #0a0a0a !important;
}

.status-under-review {
  background: #c1ff72 !important;
}

.status-await-unconditional {
  background: #9be47b !important;
}

.status-success {
  background: #63b68e !important;
}

.status-booked {
  background: #72a1e8 !important;
}

.status-yellow-booking {
  background: #fff500 !important;
}

deep-chat {
  position: fixed !important;
  z-index: 100000;
  overflow: hidden;
  right: 0;
  bottom: 0;
  z-index: 100;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.ask-bot {
  position: fixed !important;
  z-index: 100000;
  right: 10px;
  bottom: 10px;
  border-radius: 50%;
  width: 60px;
  height: 60px;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
}

.ask-bot > img {
  width: 40px;
  border-radius: 50%;
}

deep-chat,
.ask-bot {
  background: linear-gradient(
    90deg,
    rgb(239, 242, 247) 0%,
    7.60286%,
    rgb(237, 240, 249) 15.2057%,
    20.7513%,
    rgb(235, 239, 248) 26.297%,
    27.6386%,
    rgb(235, 239, 248) 28.9803%,
    38.2826%,
    rgb(231, 237, 249) 47.585%,
    48.1216%,
    rgb(230, 236, 250) 48.6583%,
    53.1306%,
    rgb(228, 236, 249) 57.6029%,
    61.5385%,
    rgb(227, 234, 250) 65.4741%,
    68.7835%,
    rgb(222, 234, 250) 72.093%,
    75.7603%,
    rgb(219, 230, 248) 79.4275%,
    82.8265%,
    rgb(216, 229, 248) 86.2254%,
    87.8354%,
    rgb(213, 228, 249) 89.4454%,
    91.8605%,
    rgb(210, 226, 249) 94.2755%,
    95.4383%,
    rgb(209, 225, 248) 96.6011%,
    98.3005%,
    rgb(208, 224, 247) 100%
  );
}

deep-chat::before {
  content: '';
  cursor: pointer;
  background: url('https://st3.depositphotos.com/8950810/17657/v/450/depositphotos_176577870-stock-illustration-cute-smiling-funny-robot-chat.jpg');
  background-size: 40px;
  position: absolute;
  z-index: 100000;
  left: 5px;
  top: 10px;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: block;
}
</style>
